import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names; when two Tailwind classes set the same thing (h-8 and
 * h-7), the later one wins. Without the merge the stylesheet's order decides,
 * so overrides passed through `className` would silently not apply.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
